import React, { useEffect, useState } from "react";

import { ChevronLeft, Edit } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { connect } from "react-redux";

import CsvColumnsAppendTableItem from "./CsvColumnsAppendTableItem";

export const appendableCSVColumns = [
  // { id: "#", label: "No" },
  {
    id: "name",
    label: "name",
    align: "center",
    required: true,
    appendable: true,
  },
  {
    id: "email",
    label: "email",
    align: "center",
    required: true,
    appendable: true,
  },
  {
    id: "csv",
    label: "csv",
    align: "center",
    required: true,
    appendable: true,
  },
];

const CSV = ({ setFiles, tableData, setTableData, flag }) => {
  const [appendableColumns, setAppendableColumns] =
    useState(appendableCSVColumns);

  useEffect(() => {
    if (flag) {
      setAppendableColumns(
        appendableCSVColumns.filter(
          (col) => col.id === "name" || col.id === "email"
        )
      );
    } else {
      setAppendableColumns(appendableCSVColumns);
    }
  }, [flag]);

  const _handleTableColumnSelect = (selectedColumn, appendedValue) => {
    // Make a copy of the current state
    const updatedData = { ...tableData };

    // Find the index of the selected column in the columns array
    const columnIndex = updatedData?.columns?.findIndex(
      (column) => column?.Header === selectedColumn
    );

    // If the column is found, add the appendedValue property
    if (columnIndex !== -1) {
      updatedData.columns[columnIndex] = {
        ...updatedData?.columns[columnIndex],
        appendedValue,
      };

      // Update the state with the new data
      setTableData(updatedData);
      setAppendableColumns((prev) =>
        prev?.filter((c) => c?.id !== appendedValue)
      );
    } else {
      console.error(`Column with Header "${selectedColumn}" not found.`);
    }
  };

  const _handleTableColumnUnSelect = (selectedColumn) => {
    // Make a copy of the current state
    const updatedData = { ...tableData };

    // Find the index of the selected column in the columns array
    const columnIndex = updatedData?.columns.findIndex(
      (column) => column?.Header === selectedColumn
    );

    // If the column is found, add the appendedValue property
    if (columnIndex !== -1) {
      const appendedValue = updatedData?.columns[columnIndex].appendedValue;
      updatedData.columns[columnIndex] = {
        Header: updatedData.columns[columnIndex].Header,
        accessor: updatedData.columns[columnIndex].accessor,
      };

      // Update the state with the new data
      setTableData(updatedData);

      const appendableColumn = appendableCSVColumns?.find(
        (c) => c.id === appendedValue
      );

      setAppendableColumns((prev) => [...prev, appendableColumn]);
    } else {
      console.error(`Column with Header "${selectedColumn}" not found.`);
    }
  };
  const _handleTableDataRemove = () => {
    setAppendableColumns(appendableCSVColumns);
    setFiles(null);
    setTableData(null);
  };

  const validateData = () => {
    const requiredFieldsString = appendableColumns
      .reduce((accumulator, currentValue) => {
        if (currentValue.required) {
          accumulator?.push(currentValue.label);
        }
        return accumulator;
      }, [])
      .join(", ");

    if (requiredFieldsString) {
      enqueueSnackbar(
        `${requiredFieldsString} ${
          requiredFieldsString?.includes(",") ? "fields are" : "field is"
        } required!`,
        {
          autoHideDuration: 3000,
          variant: "warning",
        }
      );
      return false;
    }

    return true;
  };

  return (
    <Box>
      {tableData?.columns.length < 3 && (
        <Typography
          fontSize="20px"
          fontFamily="Outfit"
          textAlign="center"
          fontWeight={500}
          color="#697277"
        >
          Your data must have at least 3 columns
        </Typography>
      )}

      <Box width="100%">
        <Box
          display="flex"
          alignItems="center"
          justifyContent={flag ? "flex-start" : "space-between"}
          mb={1}
        >
          {flag && (
            <IconButton
              onClick={() => setFiles([])}
              size="small"
              sx={{ border: "1px solid #B1B1B1", mr: 1, padding: 0 }}
            >
              <ChevronLeft sx={{ fontSize: 16, color: "#B1B1B1" }} />
            </IconButton>
          )}
          <Typography
            fontSize={flag ? "17px" : "20px"}
            fontFamily="Outfit"
            fontWeight={500}
            color="#697277"
          >
            Check table mapping
          </Typography>
          {!flag && (
            <IconButton onClick={() => setFiles([])}>
              <Edit />
            </IconButton>
          )}
        </Box>
        <Box
          display={{ xs: "none", md: "flex" }}
          justifyContent="space-between"
          alignItems="center"
          pt={1}
          px={3}
        >
          <Typography
            fontSize={{ xs: "15px", md: flag ? "16px" : "18px" }}
            fontWeight={500}
            fontFamily="Outfit"
            color="#697277"
            textAlign="left"
            width="100%"
          >
            FILE HEADER
          </Typography>
          <Typography
            fontSize={{ xs: "15px", md: flag ? "16px" : "18px" }}
            fontWeight={500}
            fontFamily="Outfit"
            color="#697277"
            textAlign="left"
            width="100%"
          >
            DATA
          </Typography>
          <Typography
            fontSize={{ xs: "15px", md: flag ? "16px" : "18px" }}
            fontWeight={500}
            fontFamily="Outfit"
            color="#697277"
            textAlign="left"
            width="100%"
          >
            APPEND FIRST
          </Typography>
        </Box>
        {tableData?.columns?.map((column, i) => {
          const allTableData = tableData?.data;
          let tableItem = { column: column?.Header, data: [] };

          if (column?.appendedValue) {
            tableItem.appendedValue = column?.appendedValue;
          }

          for (let i = 0; i < allTableData?.length; i++) {
            if (allTableData[i][`${column?.Header}`]) {
              // eslint-disable-next-line no-unsafe-optional-chaining
              tableItem = {
                ...tableItem,
                data: [
                  ...tableItem?.data,
                  allTableData[i][`${column?.Header}`],
                ],
              };

              if (tableItem?.data.length === 3) break;
            }
          }

          return (
            <CsvColumnsAppendTableItem
              key={i}
              table={tableItem}
              appendableColumns={appendableColumns}
              onAppendableColumnsChange={setAppendableColumns}
              appendableCSVColumns={appendableCSVColumns}
              onTableColumnUnSelect={_handleTableColumnUnSelect}
              onTableColumnSelect={_handleTableColumnSelect}
            />
          );
        })}
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  userId: state.auth?.user?.id,
});

export default connect(mapStateToProps)(CSV);
